import { render, staticRenderFns } from "./pkRanking.vue?vue&type=template&id=0e6f8ade&scoped=true"
import script from "./pkRanking.vue?vue&type=script&lang=ts"
export * from "./pkRanking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f8ade",
  null
  
)

export default component.exports